export default __webpack_public_path__ + "61f7952c6aadf72b60f4941bdb7806b4.svg";